module.exports = "https://s91588.cdn.ngenix.net/home/_next/static/images/variant-b-osago-a3b497de966228965204240d444b8aca.png";